//# sourceMappingURL=my-date.interface.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/EZepeda/Desktop/Explora/adminexplora/~/mydatepicker/dist/interfaces/my-date.interface.js
// module id = ../../../../mydatepicker/dist/interfaces/my-date.interface.js
// module chunks = 4